export default {
    meta: {
        title: '鱼你在一起-拓店任务先选详情',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
